import React from 'react'
import { IconFileUpload } from '@tabler/icons-react'
import Typography from 'src/components/atoms/Typography'
import { cn } from 'src/enviroment/lib/utils'

interface CopaDropzonePanelProps {
  rootProps: React.HTMLAttributes<HTMLDivElement>
  inputProps: React.InputHTMLAttributes<HTMLInputElement>
  isDragActive: boolean
  title: string
  description?: string
  hint?: string
  error?: string | null
  onCancel: () => void
  className?: string
}

/** The dashed drop target shared by the COPA single- and multi-file dropzones. */
const CopaDropzonePanel: React.FC<CopaDropzonePanelProps> = ({
  rootProps,
  inputProps,
  isDragActive,
  title,
  description,
  hint,
  error,
  onCancel,
  className,
}) => (
  <div
    {...rootProps}
    className={cn(
      'relative flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed bg-gray-800 p-6 transition-colors',
      isDragActive ? 'border-light-green-500' : 'border-gray-300',
      className,
    )}
  >
    <input {...inputProps} />
    <div className="flex w-full flex-col items-center gap-3">
      <div className="flex flex-col items-center gap-1.5">
        <IconFileUpload className="h-5 w-5 text-light-green-500" stroke={1.5} />
        <Typography variant="sm-semibold" className="text-center leading-[18px] text-gray-50">
          {title}
        </Typography>
      </div>
      {(description || hint) && (
        <div className="flex w-full flex-col items-start gap-1.5 text-center">
          {description && (
            <Typography variant="xs" className="w-full text-center leading-[16px] text-gray-200">
              {description}
            </Typography>
          )}
          {hint && (
            <Typography
              variant="xs"
              className="w-full whitespace-pre-wrap text-center text-[10px] leading-[14px] text-gray-200"
            >
              {hint}
            </Typography>
          )}
        </div>
      )}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation()
          onCancel()
        }}
        className="mt-1 flex items-center justify-center rounded-full px-3 py-1.5"
      >
        <Typography variant="sm-medium" className="leading-[18px] text-light-green-500 underline">
          Cancel upload
        </Typography>
      </button>
    </div>
    {error && (
      <Typography variant="sm" className="mt-2 text-center text-red-500">
        {error}
      </Typography>
    )}
  </div>
)

export default CopaDropzonePanel
